import React, { Fragment, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { startLoadingProjectById, startLoadingProjects, startLoadingRecommendations, startLoadingWorktypes } from '../../actions/project';
import { startFetchingUserByAccount } from '../../actions/user';
import { projectSelector, userSelector, isInitialisationTerrealSelector } from '../../selectors';
import StepsContainer from '../container-steps';
import PageCreateProject from '../overlay-create-project/page-create-project';
import PageError from '../page-error';
import PageParameter from '../page-parameter';
import PageProjectList from '../page-project-list';
import LoadingView from '../view-loading';
import DashboardDesktop from './Layouts/DashboardDesktop';
import DashboardMobile from './Layouts/DashboardMobile';
import PMDC from '../../utils/pmdc';
import { setTerrealAccountActivationOverlay, setIframeOverlay } from '../../actions/overlay';
import DashboardTablet from './Layouts/DashboardTablet';
import { BottomBlock, PageCreateProjectContainer, ProjectBody, StepsBlock, ViewProject } from './styled';
export const StepsRenderer = () => {
  return /*#__PURE__*/React.createElement(StepsBlock, null, /*#__PURE__*/React.createElement(StepsContainer, null));
};
const ProjectPage = () => {
  const dispatch = useDispatch();
  const {
    params: {
      id: currentProjectId
    }
  } = useRouteMatch();
  const [state, setState] = useState({
    isMobile: false,
    isTabletOrMobile: false
  });
  const {
    profile,
    profileLoading,
    profileError,
    hubspotChatEnabled,
    accessToken,
    decodedAccessToken
  } = useSelector(userSelector);
  const isInitialisationTerreal = useSelector(isInitialisationTerrealSelector);
  if (hubspotChatEnabled) {
    PMDC(accessToken, decodedAccessToken).getHubspotToken().then(hubspotToken => {
      window.hsConversationsSettings = {
        identificationEmail: profile.email,
        identificationToken: hubspotToken.data
      };
      window.HubSpotConversations.widget.load();
    }).catch(error => {
      console.error("Une erreur s'est produite lors de la récupération du token HubSpot :", error);
    });
  }
  const {
    page,
    selectedProject,
    selectedProjectLoading,
    selectedProjectError,
    projects,
    projectsLoading,
    projectsError,
    paginationParams,
    workTypes,
    workTypesLoading,
    worktypesError,
    recommendations,
    recommendationsLoading,
    recommendationsError
  } = useSelector(projectSelector);
  const loading = profileLoading || selectedProjectLoading || projectsLoading || workTypesLoading || recommendationsLoading;
  const error = profileError || selectedProjectError || projectsError || worktypesError || recommendationsError;
  const renderTabletAndMobilePages = useCallback(project => {
    switch (page) {
      case 'projet':
        return /*#__PURE__*/React.createElement(BottomBlock, null, /*#__PURE__*/React.createElement(DashboardMobile, {
          project: project
        }));
      case 'switch':
        return /*#__PURE__*/React.createElement(PageProjectList, null);
      case 'parametres':
        return /*#__PURE__*/React.createElement(PageParameter, null);
      case 'page-create-new-project':
        return /*#__PURE__*/React.createElement(PageCreateProjectContainer, null, /*#__PURE__*/React.createElement(PageCreateProject, {
          showTitle: false
        }));
      default:
        return null;
    }
  }, [page]);
  const setIsMobile = () => {
    setState(prev => ({
      ...prev,
      isMobile: window.innerWidth < 769,
      isTabletOrMobile: window.innerWidth < 1025
    }));
  };
  React.useEffect(() => {
    setIsMobile();
    window.addEventListener('resize', setIsMobile);
    return () => {
      window.removeEventListener('resize', setIsMobile);
    };
  }, []);

  // Get profile
  React.useEffect(() => {
    if (!profile) {
      dispatch(startFetchingUserByAccount());
    }
  }, [profile]);

  // Get project by id
  React.useEffect(() => {
    if (profile && currentProjectId) {
      dispatch(startLoadingProjectById(currentProjectId));
      dispatch(startLoadingProjects(paginationParams));
    }
  }, [profile, currentProjectId]);

  // If new terreal account, dispatch overlay alert
  React.useEffect(() => {
    if (isInitialisationTerreal) {
      dispatch(setTerrealAccountActivationOverlay());
    }
  });

  // Get projects
  React.useEffect(() => {
    if (profile && !projects && !projectsError) {
      dispatch(startLoadingProjects(paginationParams));
    }
  }, [profile, projects, projectsError]);

  // Get worktypes
  React.useEffect(() => {
    if (profile && !workTypes && !worktypesError) {
      dispatch(startLoadingWorktypes());
    }
  }, [profile, workTypes, worktypesError]);

  // Get recommendations
  React.useEffect(() => {
    if (profile && !recommendations && !recommendationsError) {
      dispatch(startLoadingRecommendations());
    }
  }, [profile, recommendations, recommendationsError]);
  return /*#__PURE__*/React.createElement(ViewProject, null, /*#__PURE__*/React.createElement(ProjectBody, {
    className: "projectBody"
  }, loading ? /*#__PURE__*/React.createElement(LoadingView, null) : error ? /*#__PURE__*/React.createElement(PageError, {
    error: error
  }) : selectedProject && /*#__PURE__*/React.createElement(Fragment, null, state.isTabletOrMobile ? /*#__PURE__*/React.createElement(Fragment, null, renderTabletAndMobilePages(selectedProject)) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(BottomBlock, null, /*#__PURE__*/React.createElement(DashboardDesktop, {
    project: selectedProject
  })), /*#__PURE__*/React.createElement(StepsRenderer, null)))));
};
export default ProjectPage;